import { ChevronsLeft, ChevronsRight } from 'lucide-react'
import styled from 'styled-components'

export const PanelContainer = styled.div`
  width: 20rem;
  height: 80vh;
  background-color: ${({ theme }) => theme.forecast.background3};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  padding: 1rem;
  overflow-y: auto;
  border-radius: 1rem;
`

export const PanelHeader = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.forecast.activeText};
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
`

export const FormSection = styled.div`
  margin-bottom: 1.5rem;
`

export const SectionTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.secondaryText};
  margin-bottom: 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.forecast.border};
`

export const InputRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
`

export const InputColumn = styled.div`
  flex: 1;
`

export const PercentageControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const PercentageDisplay = styled.div`
  min-width: 3rem;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 0.875rem;
`

export const rotationOptions = [
  { value: '0', label: '0°' },
  { value: '90', label: '90°' },
  { value: '180', label: '180°' },
  { value: '270', label: '270°' },
]

export const ChevronLeftIcon = styled(ChevronsLeft)`
  transform: scaleY(3) scaleX(1.2);
`

export const ChevronRightIcon = styled(ChevronsRight)`
  transform: scaleY(3) scaleX(1.2);
`

export const PanelWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  min-height: 80vh;
`

export const PanelPlaceholder = styled.div`
  min-height: 80vh;
`

export const ToggleButton = styled.button`
  position: absolute;
  left: -1.5rem;
  top: 50%;
  transform: translateY(-50%);

  width: 1.5rem;
  height: 5rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 1rem 0 0 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`
